import React from "react";
import styles from "./styles.module.scss";
import { LearnerOurMission } from "apps/user/learner/api/types";
import { useTranslation } from "lib/i18n/use-translation";
interface SettingsOurMissionProps {
  mission: LearnerOurMission;
}
const SettingsOurMission = ({ mission }: SettingsOurMissionProps) => {
  const { t } = useTranslation(["settings"]);
  return (
    <div className={styles["settings-our-mission"]}>
      <h1>{mission?.title}</h1>

      <h2>{mission?.heading}</h2>

      <div className={styles["our-mission-thumb"]}>
        <img
          src={mission.imageUrl}
          alt={t("settings:header.ourMission")}
          width="100%"
        />
      </div>
      <div
        className={styles["mission-contents"]}
        dangerouslySetInnerHTML={{ __html: mission.contentHtml }}
      />
    </div>
  );
};

export default SettingsOurMission;
